// extracted by css-extract-rspack-plugin
export default {"tile":"_5739a990","item":"_415a66d1","image":"_bd0579a3","title":"_40e3824"};